import { appConfig } from './config.constants';

export const apiRoutes = {
    //AUTH
    ROUTE_LOGIN: appConfig.API_CORE + '/login',
    ROUTE_EXISTEMAIL: appConfig.API_CORE + '/registroPadre/existenciaEmail',
    ROUTE_REGISTER: appConfig.API_CORE + '/registroPadre',
    ROUTE_FORGOTPASSWORD: appConfig.API_CORE + '/cuentaPadre/olvidoContrasena',
    ROUTE_VERIFYTOKEN_FP: appConfig.API_CORE + '/cuentaPadre/aceptaRestablecerContrasena',
    ROUTE_UPDATE_PASSWORD: appConfig.API_CORE + '/cuentaPadre/actualizarContrasena',
    ROUTE_RESET_PASSWORD: appConfig.API_CORE + '/auth/cambiarContrasena',
    ROUTE_RESET_LOGIN_PASSWORD: appConfig.API_CORE + '/auth/resetContrasena',
    ROUTE_CAMBIO_ROL: appConfig.API_CORE + '/auth/cambiarRol',
    ROUTE_CONFIGURAR_PIN: appConfig.API_CORE + '/auth/pin',
    ROUTE_USUARIO_API:                appConfig.API_CORE + '/usuarioAPI',
    ROUTE_USUARIO_AP_RESTART_TOKEN:                appConfig.API_CORE + '/usuarioAPI:reiniciarToken',
    //USUARIO
    ROUTE_USUARIO: appConfig.API_CORE + '/usuario',
    ROUTE_USUARIO_RESET_PASS: appConfig.API_CORE + '/usuario/restart',
    ROUTE_USUARIO_UPDATE_PASS: appConfig.API_CORE + '/usuario/update',
    ROUTE_USUARIO_VERIFY_EMP_CODE: appConfig.API_CORE + '/usuario/codigoEmpleado',

    //BITACORA
    ROUTE_BITACORA: appConfig.API_CORE + '/bitacora',
    
    //HISTORIAL_REPORTE
    ROUTE_HISTORIAL_REPORTE: appConfig.API_CORE + '/historialReporte',

    //ROLES
    ROUTE_ROLES: appConfig.API_CORE + '/roles',
    
    //PICKING
    ROUTE_PICKING_HISTORIAL: appConfig.API_CORE + '/picking/historial',
    ROUTE_PICKING_RESUMEN: appConfig.API_CORE + '/picking/resumen',
    ROUTE_PICKING_RESUMEN_EXTRA: appConfig.API_CORE + '/picking/resumen/extra',
    ROUTE_PICKING_RESUMEN_EXTRA_DETALLE: appConfig.API_CORE + '/picking/resumen/extra/detalle',
    ROUTE_PICKING_RESUMEN_DETALLE: appConfig.API_CORE + '/picking/resumen/detalle',
    ROUTE_PICKING: appConfig.API_CORE + '/picking',

    //INVENTARIO
    ROUTE_INVENTARIO: appConfig.API_CORE + '/inventario',
    ROUTE_INVENTARIO_AJUSTE: appConfig.API_CORE + '/inventario/ajuste',
    ROUTE_INVENTARIO_EXISTENCIA: appConfig.API_CORE + '/inventario/existencia-inventario',
    ROUTE_INVENTARIO_TRASLADO: appConfig.API_CORE + '/inventario/traslado',

    //KARDEX
    ROUTE_KARDEX: appConfig.API_CORE + '/kardex',

    //UPLOAD FILE
    ROUTE_UPLOAD_FILE: appConfig.API_CORE + '/utilidades/multi-file',
    ROUTE_CREATE_URL_UPLOAD_FILE: appConfig.API_CORE + '/utilidades/url-load-file',
    
    //TIPO DETALLE
    ROUTE_TIPO_DETALLE: appConfig.API_CORE + '/tipoDetalle',
    //TIPO DETALLE
    ROUTE_PRODUCTO: appConfig.API_CORE + '/producto',
    ROUTE_PRODUCTO_QR: appConfig.API_CORE + '/producto/qr',

    //TIPO REPORTE
    ROUTE_REPORTE: appConfig.API_CORE + '/reporte',

    //TIPO DETALLE
    ROUTE_TIPO_PRESUPUESTO: appConfig.API_CORE + '/tipoPresupuesto',

    //TIPO PRESUPUESTO
    ROUTE_PRESUPUESTO: appConfig.API_CORE + '/presupuesto',
    ROUTE_PRESUPUESTO_VALIDAR: appConfig.API_CORE + '/presupuesto-validar',
    ROUTE_PRESUPUESTO_MASIVO: appConfig.API_CORE + '/presupuesto-masivo',
    ROUTE_PRESUPUESTO_DETALLE: appConfig.API_CORE + '/presupuestoPeriodo',

    //TIPO DETALLE
    ROUTE_TEMPLATES: appConfig.API_CORE + '/templates',
    ROUTE_TEMPLATES_HEADER: appConfig.API_CORE + '/templatesHeader',
    ROUTE_TEMPLATES_COLUMNA: appConfig.API_CORE + '/templatesColumna',
    ROUTE_TEMPLATES_LINEA: appConfig.API_CORE + '/templatesLinea',
    ROUTE_TEMPLATES_HOJA: appConfig.API_CORE + '/templates-hoja',

}
